import { ResidentialService } from '../questionarie-signup/questionnaire-residential/residential.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../questionarie-signup/questionnaire-residential/recommendation/recommendation.service';
import * as _ from 'underscore';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { count } from 'console';
import * as $ from 'jquery';
@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.css'],
})
export class CommonHeaderComponent implements OnInit {
  iconshow = true;
  menuIconShow = true;
  isPre_success = false;
  modalVisible = false;
  accountId;
  deviceWidth;
  // API Url
  url = environment.api_url;
  aap_url = environment.aap_url;
  showheader;
  showLogin = false;
  IsAdminLogin = false;
  queryObj = {
    hg_accountId: null,
  };
  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private recommendationService: RecommendationService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    const self = this;
   
    this.accountId = this.recommendationService.hg_accountId;
    // MenuBar closed : When menubar open, click the anywhere on the page.
    window.addEventListener('mouseup', function (event) {
      const hidetext = document.getElementById('hidetxt');
      if (
        hidetext &&
        hidetext.className &&
        hidetext.className !== 'navbar-brand logomain mt-2'
      ) {
        self.closeNav();
      }
    });

    // MenuBar closed : When menubar open, scroll the page.
    window.onscroll = function () {
      const hidetxtScroll = document.getElementById('hidetxt');
      if (
        hidetxtScroll !== null &&
        hidetxtScroll.className &&
        hidetxtScroll.className !== 'navbar-brand logomain mt-2'
      ) {
        self.closeNav();
      }
    };

    // This condition is used for to show the start over and help icon.
    if (
      window.location.href.indexOf('recommendation') > -1 ||
      window.location.href.indexOf('login') > -1 ||
      window.location.href.indexOf('pre-success') > -1 ||
      window.location.href.indexOf('success') > -1 ||
      window.location.href.indexOf('signup') > -1 ||
      window.location.href.indexOf('signupoption') > -1 ||
      window.location.href.indexOf('skippage') > -1 ||
      window.location.href.indexOf('pre-congrats') > -1 ||
      window.location.href.indexOf('congrats') > -1 ||
      window.location.href.indexOf('energyplan-confirmation') > -1 ||
      window.location.href.indexOf('ssn-check') > -1 || 
      window.location.href.indexOf('affiliate') > -1 ||
      window.location.href.indexOf('promocode') > -1 ||
      window.location.href.indexOf('admin-zipcode') > -1
    ) {
      this.iconshow = false;
    }

    if (
     
      window.location.href.indexOf('pre-success') > -1 || window.location.href.indexOf('congrats') > -1
     
  
    ) {
      this.iconshow = true;
      this.isPre_success = true
    }

    if (
     
      window.location.href.indexOf('congrats') > -1
     
  
    ) {
      this.iconshow = true;
     
    }

    if (
      window.location.href.indexOf('pre-success') > -1 ||
      window.location.href.indexOf('reset') > -1 ||
      (window.location.href.indexOf('recommendation/', this.accountId) > -1 &&
        !(
          window.location.href.indexOf(
            'recommendation/single-product',
            this.accountId
          ) > -1
        ) &&
        !(
          window.location.href.indexOf(
            'recommendation/compare-product',
            this.accountId
          ) > -1
        )) ||
      window.location.href.indexOf('pre-congrats', this.accountId) > -1 ||
      window.location.href.indexOf('skippage') > -1 ||
      window.location.href.indexOf('congrats') > -1 ||
      window.location.href.indexOf('ssn-check') > -1 ||
      window.location.href.toString().split('/')[4] === 'signup'
    ) {
      this.menuIconShow = false;
    }

    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.showheader =
      sessionStorage.getItem('hideHome') != undefined
        ? sessionStorage.getItem('hideHome')
        : 'false';
    const user = sessionStorage.getItem('userObj');
    if (
      !_.isEmpty(sessionStorage.getItem('userObj')) ||
      window.location.href.includes('signuporder')
    ) {
      this.showLogin = true;

      try{
        if(JSON.parse(sessionStorage.getItem('userObj')).userRole == 'Admin')
        {
          this.IsAdminLogin = true;
        }
      }catch{
        this.IsAdminLogin = false;
      }
    
    }


  }

  // This function is called when the "list icon" click
  openNav(event) {
    if (this.getSelectedEventClassList(event)) {
      this.router.navigateByUrl('/');
    } else {
      const elemntObjt = document.getElementById('hideprocess');
      const hidetext = document.getElementById('hidetxt');
      elemntObjt.classList.add('buttonhide');
      hidetext.classList.add('buttonhide');
      const collapse = document.getElementById('mySidebar');
      collapse.classList.add('sidemenu');
      document.getElementById('mySidebar').style.width = '250px';
      document.getElementById('main').style.marginLeft = '250px';
    }
  }

  getSelectedEventClassList(event) {
    return window.location.href.indexOf('congrats') !== -1;
  }

  // This function is called when the "close icon" click
    closeNav() {
        const elemntObjt = document.getElementById('hideprocess');
        const hidetext = document.getElementById('hidetxt');
        if (elemntObjt !== null && elemntObjt.classList.contains('buttonhide')) {
            elemntObjt.classList.remove('buttonhide');
        }
        if (hidetext !== null && hidetext.classList.contains('buttonhide')) {
            hidetext.classList.remove('buttonhide');
        }
        const collapse = document.getElementById('mySidebar');
        collapse.classList.remove('sidemenu');
        document.getElementById('mySidebar').style.width = '0';
        try{
          document.getElementById('main').style.marginLeft = '0';
        }catch{

        }
       
    }

  startOver() {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = true;
      let questionnarieObj = [];
      let percentage = '0';
      var hg_accountId = JSON.parse(sessionStorage.getItem('userObj'))._id;
      const body = new HttpParams()
        .append('questionnarieObj', questionnarieObj.toString())
        .append('userObj', user)
        .append('percentage', percentage)
        .append('hg_accountId', hg_accountId);
      this.queryObj.hg_accountId = hg_accountId;

      this.http
        .get(this.url + '/getHgUser', { params: body })
        .subscribe((res: any) => {
          const result = res;
          if (result && result.statusCode && result.statusCode === '0010') {
          } else {
            if (
              result.user.questionStatusObj != null &&
              result.user.questionStatusObj.questionStatus != 'Completed' &&
              result.userResponses &&
              result.userResponses.length > 0
            ) {
              this.http
                .post(this.url + '/deleterecordbyPending', this.queryObj)
                .subscribe((notifyres) => {
                  const notifyresult = notifyres;
                  sessionStorage.removeItem('questionStatusObj');
                  this.residentialService.userResponse.userResponses = [];
                  sessionStorage.removeItem('userResponse');
                  sessionStorage.removeItem('percentage');
                  this.residentialService.messageService({});
                  this.router.navigateByUrl('/residentialQues');
                });
            } else {
              this.residentialService.userResponse.userResponses = [];
              this.residentialService.messageService({
                currentId: null,
                questionStatus: null,
              });
              sessionStorage.removeItem('questionStatusObj');
              sessionStorage.removeItem('userResponse');
              sessionStorage.removeItem('percentage');
              this.residentialService.messageService({});
              this.router.navigateByUrl('/residentialQues');
            }
          }
        });
    } else {
      sessionStorage.removeItem('questionStatusObj');
      sessionStorage.removeItem('userResponse');
      sessionStorage.removeItem('percentage');
      this.residentialService.messageService({});
      this.residentialService.userResponse.userResponses = [];
      this.residentialService.isStartOver = true;
      this.router.navigateByUrl('/residentialQues');
    }
  }

  onClose(isVisible: boolean) {
    this.modalVisible = isVisible;
  }
  showModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.modalVisible = true;
  }
  headerMenu(selectedMenu) {
    const user = sessionStorage.getItem('userObj');
    if (user) {
      this.showLogin = true;
      let questionnarieObj = sessionStorage.getItem('userResponse');
      let percentage = sessionStorage.getItem('percentage');
      if (questionnarieObj && user) {
        const body = new HttpParams()
          .append('questionnarieObj', questionnarieObj)
          .append('userObj', user)
          .append('percentage', percentage);
        this.http
          .post(this.url + '/saveQuestions', body)
          .subscribe((res: any) => {});
      }
    }
    // Changing the logic to check the localstorage if the userResponse is empty or not
    const userResponse = sessionStorage.getItem('userResponse');
    if (
      ( userResponse != null && this.residentialService.userResponse.userResponses != null &&
        this.residentialService.userResponse.userResponses.length > 0 &&
        window.location.href.indexOf('recommendation') === -1) ||
      window.location.href.indexOf('pre-success') > -1 ||
      window.location.href.indexOf('success') > -1 ||
      window.location.href.indexOf('recommendation') > -1 ||
      window.location.href.indexOf('signuporder') > -1 ||
      window.location.href.indexOf('affiliate') > -1 ||
      window.location.href.indexOf('promocode') > -1 ||
      window.location.href.indexOf('admin-zipcode') > -1
    ) {
      if (selectedMenu) {
        sessionStorage.setItem('path', selectedMenu);
      }
      if (selectedMenu === 'startover') {
        this.startOver();
        this.residentialService.isStartOver = true;
      } else {
        const questionStatusObj =
          sessionStorage.getItem('questionStatusObj') !== undefined && sessionStorage.getItem('questionStatusObj') !== "undefined"
            ? JSON.parse(sessionStorage.getItem('questionStatusObj'))
            : null;
        if (JSON.parse(sessionStorage.getItem('questionStatusObj')) === null) {
          if (selectedMenu === 'home' || selectedMenu == '/') {
            this.router.navigateByUrl('/');
          } else if (selectedMenu === 'faq') {
            this.router.navigateByUrl('/faq');
          } else if (selectedMenu === 'giveback') {
            this.router.navigateByUrl('/giveback');
          } else if (selectedMenu === 'startover') {
            this.router.navigateByUrl('/residentialQues');
          } else if (selectedMenu === 'blog') {
            this.router.navigateByUrl('/blog');
          } else if (
            selectedMenu === 'contact-us' ||
            selectedMenu === 'precontact'
          ) {
            this.router.navigateByUrl('/faq/contact-us');
          } else if (selectedMenu === 'user-settings') {
            if (JSON.parse(sessionStorage.getItem('userObj')).hg_accountId) {
              this.router.navigate([
                'user-settings',
                JSON.parse(sessionStorage.getItem('userObj')).hg_accountId,
              ]);
            } else {
              this.router.navigate([
                'user-settings',
                JSON.parse(sessionStorage.getItem('userObj'))._id,
              ]);

              //  this.router.navigate([
              //  'user-settings',
              //      JSON.parse(sessionStorage.getItem('userObj')).userObj._id,
              //]);      
            }
          } else if (selectedMenu === 'logout') {
            sessionStorage.clear();
            this.router.navigate(['/login']);
          }
        }
        questionStatusObj.percentage = Number(
          sessionStorage.getItem('percentage')
        );
        sessionStorage.setItem(
          'questionStatusObj',
          JSON.stringify(questionStatusObj)
        );

        // for quit flow
        const accountId = window.location.href.split('/').pop();
        // let isOrdersNotExist = true;
        const userObj = new HttpParams().append('hg_accountId', accountId);
        // quit flow -> if user not completed any enrollment need to check the orders length if == 0 then consider in quit flow.
        this.http
          .get(this.url + '/getOrders', { params: userObj })
          .subscribe((res: any) => {
            const ordersRes = res;
            if (ordersRes && !_.isEmpty(ordersRes)) {
              //this.navigateByUrlPerSelectedMenu(questionStatusObj);
              this.router.navigate([
                'user-settings',
                JSON.parse(sessionStorage.getItem('userObj'))._id,
              ]);
            } else if (
              !_.isEmpty(
                sessionStorage.getItem('userObj') || _.isEmpty(ordersRes)
              )
            ) {
              this.residentialService.user = JSON.parse(
                sessionStorage.getItem('userObj')
              );
              this.residentialService.user['accountId'] =
                this.residentialService.user._id;
              if (userResponse) {
                this.residentialService.userResponse = JSON.parse(
                  localStorage.getItem('userResponse')
                );
              }
              this.residentialService.questionnaireStatusObj =
                questionStatusObj;
              const resp = this.residentialService.saveuserResponses();

              // if quitted in recommedation then create a new notification
              if (
                window.location.href.indexOf('recommendation') > -1 ||
                window.location.href.indexOf('signuporder') > -1 ||
                window.location.href.indexOf('energyplan-confirmation') > -1
              ) {

                var msg = 'Your energy usage profile is complete but no product has been selected. What are you waiting for?';

                if(this.residentialService.userResponse != null)
                {

                  const itemValue = _.findWhere(this.residentialService.userResponse.userResponses, {
                    res_question_id: '008',
                  });

                  if(itemValue != null && itemValue.fieldValue.formatedAddress != null)
                  {
                    var a = this.getFormattedAddressByState(itemValue.fieldValue.formatedAddress,itemValue.fieldValue.formatedAddress.apartment);
                    if(itemValue.fieldValue.formatedAddress != undefined && itemValue.fieldValue.formatedAddress != null && a != '' ) {
              
                      var formatted_address = itemValue.fieldValue.formatedAddress.replace(", USA","");
                      var unit = (a['apartment'] != "" && a['apartment'] != undefined?  a['apartment'] + ", " : "") ;
                      var formatted_address__ = a['street_address'] + ", " + unit + a['city'] + ", " +  a['state'] + ", " + a['zipcode'];
                      msg = "Your energy usage profile for "+formatted_address__+" is complete by no product has been selected. What are you waiting for?"
                  
                    }
                   
                    //msg = "Your energy usage profile for "+address+" is complete by no product has been selected. What are you waiting for?"
              
                  }
                  //var formatted_address = this.residentialService.formatedAddress.replace(", USA","");
                  //msg = "Complete your profile regarding "+formatted_address+" to see what energy plans Honest Gorilla is recommending for you."
              
                }
          

                const notificationObj = {
                  type: 'enrollment_not_completed',
                  hg_orders_id: null,
                  hg_accountId: this.residentialService.user._id,
                  esiid: null,
                  showNotification: true,
                  isRead: false,
                  navigation_link: null,
                  buttonUrl:
                    '/pre-success',// +
                    //this.residentialService.user._id.toString(),
                  buttonName: 'Shop Now',
                  questionnairePercent: 100,
                  title: 'WE NOTICED...',
                  message:msg,
                  processCompleted: false,
                  createdDate: this.residentialService.getCurrentDatePerCST(),
                  lastUpdatedDate:
                    this.residentialService.getCurrentDatePerCST(),
                  // createdDate: new Date().getTime(),
                  // lastUpdatedDate: new Date().getTime(),
                  createdBy: '0',
                  lastUpdatedBy: '0',
                };
                // update the notification for this account and apart from recommendation
                const queryObj = {
                  type: 'enrollment_not_completed',
                  hg_orders_id: null,
                  hg_accountId: this.residentialService.user._id,
                  esiid: null,
                  processCompleted: false,
                };

                const enrollbody = new HttpParams()
                  .append('queryObj', JSON.stringify(queryObj))
                  .append('updateObj', JSON.stringify(notificationObj));
                this.http
                  .post(this.url + '/updateNotification', enrollbody)
                  .subscribe((notifyres: any) => {
                    const notifyresult = notifyres;
                    if (notifyresult.statusCode === '002') {
                    } else {
                      if (
                        JSON.parse(sessionStorage.getItem('userObj'))
                          .hg_accountId
                      ) {
                        this.router.navigate([
                          'user-settings',
                          JSON.parse(sessionStorage.getItem('userObj'))
                            .hg_accountId,
                        ]);
                      } else {
                        this.router.navigate([
                          'user-settings',
                          JSON.parse(sessionStorage.getItem('userObj'))._id,
                        ]);
                      }
                    }
                  });
              } else {
                // update the notification for this account and apart from recommendation
                const queryObj = {
                  type: 'questionnarie_not_completed',
                  hg_orders_id: null,
                  hg_accountId: this.residentialService.user._id,
                  esiid: null,
                };
                const updateObj = {
                  questionnairePercent: Number(questionStatusObj.percentage),
                  showNotification: true,
                  isRead: false,
                  processCompleted: false,
                };
                const enrollbody = new HttpParams()
                  .append('queryObj', JSON.stringify(queryObj))
                  .append('updateObj', JSON.stringify(updateObj));
                this.http
                  .post(this.url + '/updateNotification', enrollbody)
                  .subscribe((res: any) => {
                    const notifyresult = res;
                    if (notifyresult.statusCode === '002') {
                    } else {
                      if (
                        sessionStorage.getItem('path') === 'home' ||
                        sessionStorage.getItem('path') == '/'
                      ) {
                        this.router.navigateByUrl('/');
                      } else if (sessionStorage.getItem('path') === 'faq') {
                        this.router.navigateByUrl('/faq');
                      } else if (
                        sessionStorage.getItem('path') === 'giveback'
                      ) {
                        this.router.navigateByUrl('/giveback');
                      } else if (
                        sessionStorage.getItem('path') === 'startover'
                      ) {
                        this.router.navigateByUrl('/residentialQues');
                      } else if (sessionStorage.getItem('path') === 'blog') {
                        this.router.navigateByUrl('/blog');
                      } else if (
                        sessionStorage.getItem('path') === 'contact-us' ||
                        sessionStorage.getItem('path') === 'precontact'
                      ) {
                        this.router.navigateByUrl('/faq/contact-us');
                      } else if (
                        sessionStorage.getItem('path') === 'user-settings'
                      ) {
                        if (
                          JSON.parse(sessionStorage.getItem('userObj'))
                            .hg_accountId
                        ) {
                          this.router.navigate([
                            'user-settings',
                            JSON.parse(sessionStorage.getItem('userObj'))
                              .hg_accountId,
                          ]);
                        } else {
                          this.router.navigate([
                            'user-settings',
                            JSON.parse(sessionStorage.getItem('userObj'))._id,
                          ]);
                        }
                      } else if (sessionStorage.getItem('path') === 'logout') {
                        sessionStorage.clear();
                        this.router.navigateByUrl('/login');
                      } else {
                        if (
                          JSON.parse(sessionStorage.getItem('userObj'))
                            .hg_accountId
                        ) {
                          this.router.navigate([
                            'user-settings',
                            JSON.parse(sessionStorage.getItem('userObj'))
                              .hg_accountId,
                          ]);
                        } else {
                          this.router.navigate([
                            'user-settings',
                            JSON.parse(sessionStorage.getItem('userObj'))._id,
                          ]);
                        }
                      }
                    }
                  });
              }
              // }
            } else {
              if (
                !this.residentialService.isStartOver ||
                _.isEmpty(sessionStorage.getItem('userObj'))
              ) {
                if (
                  window.location.href.indexOf('recommendation') > -1 ||
                  window.location.href.indexOf('signuporder') > -1
                ) {
                  questionStatusObj.enrollmentState = 'Quitted';
                }
                sessionStorage.setItem(
                  'questionStatusObj',
                  JSON.stringify(questionStatusObj)
                );
                this.router.navigateByUrl('/skippage');
              } else {
                if (
                  JSON.parse(sessionStorage.getItem('userObj')).hg_accountId
                ) {
                  this.router.navigate([
                    'user-settings',
                    JSON.parse(sessionStorage.getItem('userObj')).hg_accountId,
                  ]);
                } else {
                  this.router.navigate([
                    'user-settings',
                    JSON.parse(sessionStorage.getItem('userObj'))._id,
                  ]);
                }
              }
            }
          });
      }
    } else {
      if (selectedMenu) {
        sessionStorage.setItem('path', selectedMenu);
      }

      if (
        !this.residentialService.isStartOver ||
        _.isEmpty(sessionStorage.getItem('userObj'))
      ) {
        if (selectedMenu === 'home' || selectedMenu == '/') {
          this.router.navigateByUrl('/');
        } else if (selectedMenu === 'faq') {
          //alert("hh");
          this.router.navigateByUrl('/faq');
        } else if (selectedMenu === 'giveback') {
          this.router.navigateByUrl('/giveback');
        } else if (selectedMenu === 'startover') {
          this.router.navigateByUrl('/residentialQues');
        } else if (selectedMenu === 'blog') {
          this.router.navigateByUrl('/blog');
        } else if (
          selectedMenu === 'contact-us' ||
          selectedMenu === 'precontact'
        ) {
          this.router.navigateByUrl('/faq/contact-us');
        } else if (selectedMenu === 'user-settings') {
          if (JSON.parse(sessionStorage.getItem('userObj')).hg_accountId) {
            this.router.navigate([
              'user-settings',
              JSON.parse(sessionStorage.getItem('userObj')).hg_accountId,
            ]);
          } else {
            this.router.navigate([
              'user-settings',
              JSON.parse(sessionStorage.getItem('userObj'))._id,
            ]);
          }
        } else if (selectedMenu === 'logout') {
          sessionStorage.clear();
          this.router.navigateByUrl('/login');
        }
      } else {
        if (JSON.parse(sessionStorage.getItem('userObj')).hg_accountId) {
          this.router.navigate([
            'user-settings',
            JSON.parse(sessionStorage.getItem('userObj')).hg_accountId,
          ]);
        } else {
          this.router.navigate([
            'user-settings',
            JSON.parse(sessionStorage.getItem('userObj'))._id,
          ]);
        }
      }
    }
  }

  navigateByUrlPerSelectedMenu(questionStatusObj) {
    if (
      window.location.href.indexOf('recommendation') > -1 ||
      window.location.href.indexOf('signuporder') > -1
    ) {
      questionStatusObj.enrollmentState = 'Quitted';
      questionStatusObj.percentage = '100';
    }
    sessionStorage.setItem(
      'questionStatusObj',
      JSON.stringify(questionStatusObj)
    );
    this.router.navigateByUrl('/skippage');
  }

  getFormattedAddressByState(address,apt) {
    let temp_address = {};
    try{
     
      let address_ = address;
      if (address_ != "" && address_ != "undefined") {
        let address = address_.split(',');
        let [state, zipcode] = address[2] ? address[2].trim().split(' ') : '';
        if (address[0].toUpperCase().indexOf('APT') > 1) {
          temp_address['street_address'] = address[0].substring(
            0,
            address[0].toUpperCase().indexOf('APT') - 1
          );
          temp_address['apartment'] = address[0].substring(address[0].toUpperCase().indexOf('APT') + 4);
        } else {
          temp_address['street_address'] = address[0];
          temp_address['apartment'] = apt;
        }
        temp_address['city'] = address[1] ? address[1].trim() : '';
        temp_address['state'] = state ? state : '';
        temp_address['zipcode'] = zipcode ? zipcode : '';
      }
      return temp_address;

    }catch{
    
     
      return '';


    }
  
  }

  Redirect(link)
  {
    this.router.navigate([
      link,
     
    ]);
  }
}
